import React from 'react';
import get from 'lodash/get';
import find from 'lodash/find';
import { connect } from 'react-redux';
import {Alert, Icon, Layout, Input, Select, Table, Menu, Dropdown, Tooltip, Button, Checkbox } from 'antd';
import { Link } from 'react-router-dom';

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import Footer from '../../components/Footer/Footer';
import classes from './Enrolments.css';

import isAuthenticated from '../../utils/isAuthenticated';
import { getSubjectSearchRequest, getSitesRequest } from '../../api/requests';
import { logout } from "../../reducers/user/actions";
import { withParams } from '../../utils/url';
import moment from "moment";
import {getUserShortTimezone, getUserTimezone} from "../../reducers/user/selectors";

const routes = require('../../routes.json');

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

const renderIcon = status => {
  return (<div className={classes.iconStatusWrapper}>
    {status === 'green' && <Icon type="check-square" className={classes.checkIcon} />}
    {status === 'red' && <Icon type="warning" className={classes.warningIcon} />}
    {status === 'orange' && <Icon type="clock-circle" className={classes.clockIcon} />}
    {status === 'gray' && <Icon type="clock-circle" className={classes.checkIconGray} />}
    {status === 'pending' && <Icon type="clock-circle" className={classes.checkIconGray} />}
  </div>)
};

const eventList = {'randomize': 'Randomize', 'consent': 'Consent', 'validation': 'Validation', 'deviation': 'Deviation', 'profile': 'Profile', 'registry_id': 'Registry id', 'follow_up_90_days': 'Follow up 90 days', 'sae': 'SAE', 'death': 'Death'};


class Enrolments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subject: [],
      subjectID: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      order: 'asc',
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: { columnKey: 'site', order: 'ascend'},
    };
  }

  async componentDidMount() {
    this.onSubjectSearch();

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) { if (get(e, 'response.status') === 401) { this.props.logout();  return; } console.log(e);}

  }

  onSubjectSearch = async (value) => {
    this.setState({ subjectID: value, filter: null, site: null, eventsSelected: {} }, this.getSubjects);
  };

  getSubjects = async (page = this.state.currentPage, per_page = this.state.pageSize) => {
    this.setState({ errorMessage: null, isLoading: true, responseMessage: null });

    try {
      const { data } = await getSubjectSearchRequest({
        subjectID: this.state.subjectID,
        filter_by: this.state.filter,
        site_code: this.state.site,
        events: Object.keys(this.state.eventsSelected).join(','),
        event_status: Object.values(this.state.eventsSelected).join(','),
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, 'sortedInfo.columnKey'),
      });

      if (Array.isArray(data.data)) {
        this.setState({ subject: data.data, total: data.total_pages * per_page, currentPage: page });
      } else {
        this.setState({ subject: [data], total: 1 * per_page, currentPage: page });
      }
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      this.setState({ subject: null, errorMessage: get(e, 'response.data.error', 'Error') });
    }

    this.setState({ isLoading: false });
  };

  onSubjectChange = (e) => {
    this.setState({ subjectID: e.target.value });
  };

  clearFilters = () => { this.setState({ subjectID: null, site: null, filter: null, eventsSelected: {}, sortedInfo: null }, this.getSubjects); };

  handleFilterChange = (value) => { this.setState({ filter: value, site: null, eventsSelected: {}, subjectID: null, sortedInfo: null }, this.getSubjects) };
  handleSiteChange = (value) => { this.setState({ site: value, sortedInfo: null }, this.getSubjects) };
  handleOrderChange = (value) => { this.setState({ order: value, sortedInfo: null }, this.getSubjects) };

  handleMenuClick = e => {
    if (e.key === '3') {
      this.setState({ eventVisibleDropdown: false });
    }
  };

  handleVisibleChange = flag => {
    this.setState({ eventVisibleDropdown: flag });
  };

  hideEventDropdown = () => {
    this.setState({ eventVisibleDropdown: false });
  };

  onSelectEvent = eventName => () => {
    this.setState(state => {
      let eventsSelected;

      if ([true, false].includes(state.eventsSelected[eventName])) {
        eventsSelected = {...state.eventsSelected };
        delete eventsSelected[eventName];
      } else {
        eventsSelected = {...state.eventsSelected, [eventName]: true };
      }

      if (eventName === 'sae') {
        if (['not_entered', 'is_occurred', 'not_occurred'].includes(state.eventsSelected[eventName])) {
          eventsSelected = {...state.eventsSelected };
          delete eventsSelected[eventName];
        } else {
          eventsSelected = {...state.eventsSelected, [eventName]: 'not_occurred' };
        }
      }

      return { eventsSelected, sortedInfo: null };
    }, this.getSubjects);
  };

  onSelectEventOccured = (eventName, value) => () => {
    this.setState(state => {
      let eventsSelected = state.eventsSelected[eventName] ? {...state.eventsSelected, [eventName]: false } : {...state.eventsSelected, [eventName]: true };

      if (eventName === 'sae') {
        if (get(state, 'eventsSelected.sae') === value) {
          eventsSelected.sae = 'not_occurred';
        } else {
          eventsSelected.sae = value;
        }
      }

      return {
        eventsSelected,
        sortedInfo: null
      };
    }, this.getSubjects);
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      isLoading: true,
      pageSize: pagination.pageSize,
      sortedInfo: sorter,
      order: get(sorter, 'order') === 'ascend' ? 'asc' : get(sorter, 'order') === 'descend' ? 'desc' : 'asc',
    }, () => this.getSubjects(pagination.current, pagination.pageSize));
  };

  render() {
    const { errorMessage, isLoading, responseMessage, subjectID, subject, sites, site, filter, order, currentPage, total, pageSize, eventVisibleDropdown, eventsSelected, sortedInfo } = this.state;

    const columns = [
      {
        dataIndex: "site",
        key: "site",
        title: "Site",
        render: val => (<span>{get(val, 'name')}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'site' && sortedInfo.order,
      },
      {
        dataIndex: "code",
        key: "code",
        title: "Subject",
        render: val => <Tooltip placement="topLeft" title="View Subject Profile"><Link to={withParams(routes.admin.patientProfileSingle, { subjectID: val})}>{val}</Link></Tooltip>,
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'code' && sortedInfo.order,
      },
      {
        dataIndex: "profile",
        key: "registry_id",
        title: "Registry ID",
        render: val => {
          const quicrRegistryId = get(val, 'quicr_registry_id');
          const optimizeRegistryId = get(val, 'optimize_registry_id');

          return (<span>{
            quicrRegistryId || optimizeRegistryId ? `${quicrRegistryId} ${(quicrRegistryId && optimizeRegistryId) ? '/' : ''} ${optimizeRegistryId ? optimizeRegistryId : ''}`: '-'
          }</span>)
        },
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'registry_id' && sortedInfo.order,
      },
      {
        dataIndex: "randomization_date",
        key: "randomization_date",
        title: "Randomization date",
        render: val => (<span>
          {moment
            .utc(val)
            .tz(this.props.userTimezone || "UTC")
            .format("YYYY-MM-DD HH:mm")}{" "}
          {this.props.userShortTimezone || "UTC"}
        </span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'randomization_date' && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "randomize",
        title: "Randomization",
        render: val => (<span>{renderIcon(get(find(val, event => event.event === 'randomize'), 'status'))}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'randomize' && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "consent",
        title: "Consent",
        render: val => (<span>{renderIcon(get(find(val, event => event.event === 'consent'), 'status'))}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'consent' && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "validation",
        title: "Validation",
        render: val => (<span>{renderIcon(get(find(val, event => event.event === 'validation'), 'status'))}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'validation' && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "deviation",
        title: "Deviation",
        render: val => (<span>{renderIcon(get(find(val, event => event.event === 'deviation'), 'status'))}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'deviation' && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "profile",
        title: "Patient profile",
        render: val => (<span>{renderIcon(get(find(val, event => event.event === 'profile'), 'status'))}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'profile' && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "sae",
        title: "SAE",
        render: val => (<span>{renderIcon(get(find(val, event => event.event === 'sae'), 'status'))}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'sae' && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "follow_up_90_days",
        title: "90-Day Follow UP",
        render: val => (<span>{renderIcon(get(find(val, event => event.event === 'follow_up_90_days'), 'status'))}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'follow_up_90_days' && sortedInfo.order,
      },
      {
        dataIndex: "events_summary_report",
        key: "death",
        title: "Death",
        render: val => (<span>{get(find(val, event => event.event === 'death'), 'status') !== 'none' && <span>Yes</span>}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'death' && sortedInfo.order,
      }
    ];

    return (
        <div style={{ backgroundColor: '#FAFAFA' }}>
            <Layout className={classes.parentContainer}>
                <AdminHeader />
                <Content className={classes.content}>
                  <h3 className='headline-default'>Enrolled Patients Summary</h3>

                  <div className={classes.searchWrapper}>
                    <label className={classes.searchWrapperSearch}>
                      <b className={classes.searchWrapperLabel}>SEARCH</b>
                      <Search
                        placeholder="By subject ID"
                        enterButton="Search"
                        size="large"
                        onSearch={this.onSubjectSearch}
                        value={subjectID}
                        onChange={this.onSubjectChange}
                        style={{ maxWidth: '500px'}}
                      />
                    </label>

                    <div className={classes.searchWrapperFilter}>
                      <label className={classes.searchWrapperFilterItem}>
                        <b className={classes.searchWrapperLabel}>Filter by</b>
                        <Select onChange={this.handleFilterChange} value={filter} style={{ width: '100%' }} placeholder='Select'>
                          <Option value='site'>Site</Option>
                          <Option value='event'>Event</Option>
                        </Select>
                      </label>

                      {filter === 'site' && (<label className={classes.searchWrapperFilterItem}>
                        <b className={classes.searchWrapperLabel}>Site</b>
                        <Select onChange={this.handleSiteChange} value={site} style={{ width: '100%' }} placeholder='Select'>
                          {sites.map(site => (
                            <Option key={site.id} value={site.code}>{site.code} - {site.name}</Option>
                          ))}
                          <Option value=''>All sites</Option>
                        </Select>
                      </label>)}

                      {filter === 'event' && (<label className={classes.searchWrapperFilterItem}>
                        <b className={classes.searchWrapperLabel}>Event</b>
                        <br/>
                        <Dropdown overlay={(
                          <Menu onClick={this.handleMenuClick}>
                            {Object.keys(eventList).map((eventName) => (
                              <Menu.Item key={eventName} className={classes.eventDropdownItem}>
                                <Checkbox onChange={this.onSelectEvent(eventName)} checked={[true, false, 'not_entered', 'is_occurred', 'not_occurred'].includes(eventsSelected[eventName])}>{eventList[eventName]}</Checkbox>
                                {eventName !== 'sae' && [true, false].includes(eventsSelected[eventName]) && <div>
                                  <Checkbox onChange={this.onSelectEventOccured(eventName)} checked={eventsSelected[eventName]}>Has occurred?</Checkbox>
                                </div>}

                                {eventName === 'sae' && ['not_entered', 'is_occurred', 'not_occurred'].includes(eventsSelected['sae']) && <div>
                                  <Checkbox onChange={this.onSelectEventOccured(eventName, 'is_occurred')} checked={eventsSelected[eventName] === 'is_occurred'}>Has occurred?</Checkbox>
                                  <Checkbox onChange={this.onSelectEventOccured(eventName, 'not_entered')} checked={eventsSelected[eventName] === 'not_entered'}>Not entered</Checkbox>
                                </div>}
                              </Menu.Item>
                            ))}
                            <Menu.Item>
                              <Button type="primary" size="small" onClick={this.hideEventDropdown}>Ok</Button>
                            </Menu.Item>
                          </Menu>
                        )} trigger={['click']} onVisibleChange={this.handleVisibleChange} visible={eventVisibleDropdown}>
                          <div>
                            {Object.keys(eventsSelected).length > 0 ?  Object.keys(eventsSelected).map((eventName, i) => (<span key={eventName} style={{ color: eventsSelected[eventName] ? '#49C850' : '#f00'}}>{i !== 0 && ', '} {eventList[eventName]}</span>)) : <span>Select events</span> }
                          </div>
                        </Dropdown>
                      </label>)}

                      <span className={classes.clearButton} onClick={this.clearFilters}>Clear</span>
                    </div>

                  </div>

                  {errorMessage && (<Alert type='error' message={errorMessage} />)}

                  {responseMessage && (<Alert type='success' message={responseMessage} />)}

                  <Table
                    columns={columns}
                    dataSource={subject}
                    loading={isLoading}
                    rowKey="id"
                    onChange={this.handleTableChange}
                    pagination={{
                      onShowSizeChange: (current, size) => {
                        this.setState({ pageSize: size });
                      },
                      current: currentPage,
                      total,
                      pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: ['10', '25', '50', '100']
                    }}
                  />

                  {isLoading && <Icon type="loading" />}

                  <br/>

                  <h4 className="headline-default">Legend</h4>
                  <p className={classes.legendItem}>
                    <Icon type="check-square" className={classes.checkIcon} /> <b>Complete</b>
                  </p>

                  <p className={classes.legendItem}>
                    <Icon type="warning" className={classes.warningIcon} /> <b>Alert</b>
                  </p>

                  <p className={classes.legendItem}>
                    <Icon type="clock-circle" className={classes.checkIconGray} /> <b>Pending</b>
                  </p>
                </Content>
                <Footer noAdminLink />
            </Layout>
        </div>
    );
  }
}
const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(Enrolments));



// WEBPACK FOOTER //
// ./src/containers/Enrolments/Enrolments.js